import { useQueryString } from "src/design-system/core/hooks";

export const FILTER_ALERT = "filter-alert";
export const FROM = "from";
export const TO = "to";

export enum FilterAlertTypeEnum {
    OfferNotification = "offer-notification",
    OfferManagement = "offer-management",
    OfferPerformance = "offer-performance",
    SponsoredAdNotification = "sponsored-ad-notification",
    SponsoredAdManagement = "sponsored-ad-management",
    SponsoredAdPerformance = "sponsored-ad-performance",
}

interface UseFilterAlertResult {
    filterAlert?: FilterAlertTypeEnum;
    setFilterAlert: (value: FilterAlertTypeEnum | undefined) => void;
}

export function useFilterAlert(): UseFilterAlertResult {
    const [filterAlert, setFilterAlert] = useQueryString(FILTER_ALERT);

    return {
        filterAlert: filterAlert as FilterAlertTypeEnum,
        setFilterAlert,
    };
}
